import { useState, useEffect } from 'react'
import TopBar from '../../../components/TopBar'
import { getOption, updateOption } from '../../../api/optionsApi'
import UploadMediaPopup from '../../../components/UploadMediaPopup'
import styles from '../page.module.css'

const WhatsAppChat = () => {
  const [whatsappChats, setWhatsappChats] = useState([
    { icon: '', title: '', number: '', iconUrl: '' }
  ])
  const [errors, setErrors] = useState([
    { icon: '', title: '', number: '' }
  ])
  const [isShow, setIsShow] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [showUploadMediaPopup, setShowUploadMediaPopup] = useState(false)
  const [uploadMediaPopupFor, setUploadMediaPopupFor] = useState('')
  const [currentUploadIndex, setCurrentUploadIndex] = useState(null)
  const [selectedFeatureImage, setSelectedFeatureImage] = useState('')

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await getOption('whatsapp-chat')

        if (data?.data?.value?.record) {
          const resetResponse = data?.data?.value?.record?.map((item) => ({
            ...item,
            icon: item?.icon?.id,
            iconUrl: item?.icon?.url || ""
          }))
          setIsShow(data?.data?.value?.isShow || true)
          setWhatsappChats(resetResponse)
        }
      } catch (error) {
        console.error('Error loading data:', error)
      }
    }
    loadData()
  }, [])

  useEffect(() => {
    if (selectedFeatureImage && currentUploadIndex !== null) {
      const imageData = selectedFeatureImage[0]
      const updatedChats = [...whatsappChats]
      updatedChats[currentUploadIndex] = {
        ...updatedChats[currentUploadIndex],
        icon: imageData?.id || '',
        iconUrl: imageData?.url || ''
      }
      setWhatsappChats(updatedChats)
      const updatedErrors = [...errors];

      updatedErrors[currentUploadIndex] = {
        ...updatedErrors[currentUploadIndex],
        icon: '',
      };

      setErrors(updatedErrors);
      setSelectedFeatureImage('')
      setCurrentUploadIndex(null)
    }
  }, [selectedFeatureImage, currentUploadIndex])

  const validateForm = () => {
    let isValid = true

    const newErrors = whatsappChats.map((chat) => {
      const itemErrors = {
        icon: '',
        title: '',
        number: ''
      }

      if (!chat.icon) {
        itemErrors.icon = 'Icon is required'
        isValid = false
      }

      if (!chat.title?.trim()) {
        itemErrors.title = 'Title is required'
        isValid = false
      }

      if (!chat.number?.trim()) {
        itemErrors.number = 'WhatsApp number is required'
        isValid = false
      } else if (!/^[0-9]{10}$/.test(chat.number)) {
        itemErrors.number = 'WhatsApp number must be 10 digits'
        isValid = false
      }

      return itemErrors
    })

    setErrors(newErrors)

    return isValid
  }

  const handleSave = async () => {
    const isValid = validateForm()

    if (!isValid) return
    setIsLoading(true)
    try {
      const payload = whatsappChats?.map(({ iconUrl, ...rest }) => rest);
      await updateOption('whatsapp-chat', { record: payload, isShow: isShow })
    } catch (error) {
      console.error('Error saving:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleAddMore = () => {
    setWhatsappChats([...whatsappChats, { icon: '', title: '', number: '', iconUrl: '' }])
  }

  const handleRemove = (index) => {
    const updated = whatsappChats.filter((_, i) => i !== index)
    const updatedErrors = [...errors];

    updatedErrors[currentUploadIndex] = {
      ...updatedErrors[currentUploadIndex],
      icon: '',
      title: '',
      number: '',
    };

    setErrors(updatedErrors);
    setWhatsappChats(updated)
  }

  const handleImageUpload = (e, index) => {
    e.stopPropagation()
    setCurrentUploadIndex(index)
    setUploadMediaPopupFor('feature-image')
    setShowUploadMediaPopup(true)
  }

  const handleChange = (index, field, value) => {
    const updated = [...whatsappChats]
    updated[index][field] = value
    setWhatsappChats(updated)
  }

  return (
    <>
      <TopBar />
      <div className={styles.appearanceMenuSection}>
        <div className={styles.appearanceMenuBox} style={{ maxWidth: '100%' }}>
          <div className={styles.appearanceMenuBlock}>
            <div>
              {/* HEADING + TOGGLE BUTTON */}
              <div
                style={{
                  paddingBottom: 12,
                  display: 'flex',
                  gap: 15,
                  justifyContent: 'space-between',
                }}
              >
                <div className={styles.appearanceMenuBoxLabel}>
                  WhatsApp Button Show
                </div>

                {/* Toggle */}
                <div
                  onClick={() => setIsShow(!isShow)}
                  style={{
                    width: '52px',
                    height: '28px',
                    borderRadius: '30px',
                    background: isShow ? '#55883d' : '#cbd5e1',
                    position: 'relative',
                    cursor: 'pointer',
                    transition: '0.3s'
                  }}
                >
                  <div
                    style={{
                      width: '22px',
                      height: '22px',
                      borderRadius: '50%',
                      background: '#fff',
                      position: 'absolute',
                      top: '3px',
                      left: isShow ? '26px' : '3px',
                      transition: '0.3s',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
                    }}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
                {whatsappChats.map((chat, index) => (
                  <div key={index} className={styles.appearanceMenuWidgetBlock} style={{ border: '1px solid var(--ashyblue)', borderRadius: '6px', padding: '20px', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', }}>
                      <label style={{ fontSize: '16px', fontWeight: 500, color: 'var(--cloudburst)' }}>Item {index + 1}</label>
                      {whatsappChats.length > 1 && (
                        <button
                          className={styles.deleteButton}
                          onClick={() => handleRemove(index)}
                          style={{ padding: '6px 12px', fontSize: '13px', minHeight: '34px' }}
                        >
                          Remove
                        </button>
                      )}
                    </div>

                    {/* Icon Upload */}
                    <div className={styles.appearanceMenuWidgetBlock}>
                      <label >Icon</label>
                      <div className={`imageUploadBox`} onClick={(e) => handleImageUpload(e, index)} style={{ cursor: 'pointer', width: 'max-content' }}>
                        <div id={`whatsapp-icon-upload-${index}`}>
                          {chat.iconUrl ? (
                            <div className="image-preview" style={{ width: '80px', height: '80px', borderRadius: '6px', overflow: 'hidden', border: '1px solid var(--ashyblue)' }}>
                              <img src={chat.iconUrl} alt="WhatsApp Icon" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </div>
                          ) : (
                            <div className='image-upload-content'>
                              {/* <div style={{ fontSize: '40px', marginBottom: '8px' }}>📎</div> */}
                              <p>
                                <span>Click to upload for icon</span>
                                <br />
                                <span style={{ color: 'var(--grey)', fontSize: '12px' }}>SVG, PNG, JPG</span>
                              </p>
                            </div>
                          )}
                        </div>
                        <input type="file" id="whatsapp-icon-input" accept="image/*" hidden />
                      </div>
                      {errors[index]?.icon && (
                        <p
                          style={{
                            color: 'red',
                            fontSize: '12px',
                            margin: '0px'
                          }}
                        >
                          {errors[index]?.icon}
                        </p>
                      )}
                    </div>

                    {/* Title Input */}
                    <div className={styles.appearanceMenuWidgetBlock}>
                      <label >Title</label>
                      <input
                        type="text"
                        className={styles.footerTitleInput}
                        placeholder="Enter title (e.g., Customer Support)"
                        value={chat.title}
                        onChange={(e) => handleChange(index, 'title', e.target.value)}
                        style={{ width: '100%', maxWidth: '400px' }}
                      />
                      {errors[index]?.title && (
                        <p
                          style={{
                            color: 'red',
                            fontSize: '12px',
                            margin: '0px'
                          }}
                        >
                          {errors[index]?.title}
                        </p>
                      )}
                    </div>

                    {/* Number Input */}
                    <div className={styles.appearanceMenuWidgetBlock}>
                      <label >WhatsApp Number</label>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <input
                          type="text"
                          className={styles.footerTitleInput}
                          placeholder="Enter WhatsApp number (with country code)"
                          value={chat.number}
                          onChange={(e) => handleChange(index, 'number', e.target.value)}
                          style={{ width: '100%', maxWidth: '400px', }}
                        />
                      </div>
                      {errors[index]?.number && (
                        <p
                          style={{
                            color: 'red',
                            fontSize: '12px',
                            margin: '0px'
                          }}
                        >
                          {errors[index]?.number}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Add More Button */}
              <button
                className={`${styles.addBtn} ${styles.saveChangeButton}`}
                onClick={handleAddMore}
                style={{ width: 'max-content', display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '30px' }}
              >
                <span style={{ fontSize: '20px', lineHeight: '1' }}>+</span>
                Add More
              </button>
            </div>
          </div>

          <div className={styles.saveButtons}>
            <button className={`${styles.saveButton} ${styles.saveChangeButton}`} onClick={handleSave}>
              {isLoading ? <div className='ringLoader'></div> : 'Save Changes'}
            </button>
          </div>
        </div>
      </div>

      {showUploadMediaPopup && (
        <UploadMediaPopup
          showUploadMediaPopup={showUploadMediaPopup}
          setShowUploadMediaPopup={setShowUploadMediaPopup}
          setSelectedProfileImage={setSelectedFeatureImage}
          uploadMediaPopupFor={uploadMediaPopupFor}
          uploadMediaPopupTab="media"
        />
      )}
    </>
  )
}

export default WhatsAppChat
